module.exports = __webpack_public_path__ + "static/media/drops.323f7719.png";